import { render } from "./DeleteMedicationDialog.vue?vue&type=template&id=593f057f"
import script from "./DeleteMedicationDialog.vue?vue&type=script&lang=js"
export * from "./DeleteMedicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__